import React from 'react';

interface ImageControlButtonProps {
  onClick: () => void;
  disabled?: boolean;
  icon: string;
  label: string;
  title: string;
}

const ImageControlButton: React.FC<ImageControlButtonProps> = ({ onClick, disabled = false, icon, label, title }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="w-8 h-10 bg-white/70 backdrop-blur-sm hover:bg-white/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center rounded-sm"
      aria-label={label}
      title={title}
    >
      <i className={`text-stone-700 fa ${icon} text-sm`} />
    </button>
  );
};

export default ImageControlButton;

